import React from "react";
import { Facebook, Instagram } from "lucide-react";

export const Footer: React.FC = () => {
  return (
    <footer className="w-full bg-[rgba(0,63,40,1)] py-6 px-[19px]">
      <div className="w-full mx-auto flex justify-between">
        {/* Logo and Company Info */}
        <div className="flex items-center gap-2">
          <img
            src="/logo/dailokrishi-yellow.png"
            className="w-12 h-12 object-contain"
            alt="DailoKrishi logo"
            loading="lazy"
          />
          <div>
            <h2 className="text-[rgba(214,255,235,1)] text-xl font-bold">
              Dailo Krishi
            </h2>
            <p className="text-white text-xs">
              Nepal's #1 Farm to Table
            </p>
          </div>
        </div>

        {/* Social Links */}
        <div className="flex items-center gap-4">
          <a href="https://www.facebook.com/dailokrishi" className="text-white hover:text-[rgba(214,255,235,1)]">
            <Facebook className="w-6 h-6" />
          </a>
          <a href="https://www.instagram.com/dailokrishi" className="text-white hover:text-[rgba(214,255,235,1)]">
            <Instagram className="w-6 h-6" />
          </a>
        </div>
      </div>
    </footer>
  );
};
